<template>
  <BaseListPage
      :name="name"
      :table-set-list="tableSetList"
      :table-data-list="sortedList"
      :show-search-component="false"
      :show-pagination="false"
      title="ポイント設定"
      title-class="point-setting-header"
      icon="point"
      table-class="pointsetting-table-list row-clickable-table"
      @row-click="onRowClick">
    <template slot="search">
      <div class="search-dropdown">
        <label>顧客グループ</label>
        <BaseValidSelect :value="selectedGroup"
            :options="customerGroups"
            name="group"
            @input="onGroupChanged" />
        <BaseNewRegisterButton
            :store-path="storePath"
            url="pointsetting" />
      </div>
    </template>
  </BaseListPage>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

import x from '@/components/mixins/mixin'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

import BaseValidSelect from '@/components/atoms/BaseValidSelect'
import BaseListPage from '@/components/organisms/BaseListPage'
import BaseNewRegisterButton from '@/components/organisms/BaseNewRegisterButton'

export default {
  name: 'PointSetting',
  components: {
    BaseValidSelect,
    BaseListPage,
    BaseNewRegisterButton
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      customerGroups: [],
      selectedGroup: null
    }
  },
  computed: {
    ...mapState({
      tableSetList: (state) => state.PointSetting.tableSetList
    }),
    ...mapGetters({
      getSortedList: 'sortedList'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'pointSettingList'
    },
    storePath () {
      return 'PointSetting'
    },
    linkKey () {
      return 'id'
    },
    returnPath () {
      return '/pointsetting'
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      return [
        { type: 'String', label: 'ID', path: 'id', sortable: 'custom' },
        { type: 'Number', label: '付与レート', path: 'rate', fractionDigits: 2, sortable: 'custom' },
        {
          type: 'Boolean', label: '対象', path: 'target', elementType: ELEMENT_TYPE.CHECK_BOX,
          class: 'center', sortable: 'custom'
        },
        {
          type: 'Boolean', label: '税', path: 'tax', elementType: ELEMENT_TYPE.CHECK_BOX,
          class: 'center', sortable: 'custom'
        },
        {
          type: 'Boolean', label: '商品外', path: 'other', elementType: ELEMENT_TYPE.CHECK_BOX,
          class: 'center', sortable: 'custom'
        },
        { type: 'Boolean', label: 'セール品', path: 'sale', elementType: ELEMENT_TYPE.CHECK_BOX,
          class: 'center', sortable: 'custom'
        },
        { type: 'Boolean', label: '期間限定', path: 'limited', elementType: ELEMENT_TYPE.CHECK_BOX,
          class: 'center', sortable: 'custom'
        },
        { type: 'String', label: '有効期限', path: 'exp', width: '200', sortable: 'custom' },
        { type: 'String', label: 'プロモーション', path: 'code', width: '150', sortable: 'custom' },
        { type: 'String', label: '優先順位', path: 'priority', class: 'center', sortable: 'custom' },
        {
          type: 'Boolean', label: '加算', path: 'add', elementType: ELEMENT_TYPE.CHECK_BOX,
          class: 'center', sortable: 'custom'
        },
        { type: 'Date', label: '適用期間', path: 'between', width: '200', sortable: 'custom' }
      ]
    },
    listItems () {
      // TODO store の tdLists を絞り込む？
      return [
        { id: 1, rate: 1, target: true, tax: false, other: false, sale: true, limited: true, exp: '2018/10/01-2018/12/31', code: 'FW Sale', priority: 1, add: true, between: '2018/12/31' },
        { id: 2, rate: 1.3, target: true, tax: false, other: false, sale: true, limited: true, exp: '2018/10/01-2018/12/31', code: 'FW Sale', priority: 1, add: true, between: '2018/12/31' },
        { id: 3, rate: 1.5, target: true, tax: false, other: false, sale: true, limited: true, exp: '2018/10/01-2018/12/31', code: 'FW Sale', priority: 1, add: true, between: '2018/12/31' }
      ]
    }
  },
  created () {
    this.$store.dispatch({
      type: 'set',
      states: {
        'PointSetting/tableSetList': this._tableSetList
      }
    })
    this.$store.dispatch({
      type: 'set',
      states: {
        'PointSetting/tdLists': this.listItems
      }
    })

    this.customerGroups = this.getCustomerGroups()
  },
  methods: {
    getCustomerGroups () {
      return [
        { code: 1, name: '顧客グループ１' },
        { code: 2, name: '顧客グループ２' },
        { code: 3, name: '顧客グループ３' }
      ]
    },
    onGroupChanged (event) {
      this.$log.debug('change event', event)
      this.selectedGroup = event
    },
    onRowClick (row, column, event) {
      const id = _.get(row, this.linkKey)
      const index = this.$_mixin_findIndex(this.sortedList, { [this.linkKey]: id })
      this.$_mixin_onLinkClick(index, this.storePath)
      this.$router.push({ path: `/pointsetting/${id}` })
    }
  }
}
</script>
